<template>
  <div class="glod-list-box">
    <!--操作栏-->
    <div class="action-bar">
      <!-- <el-select
          v-model="query.type"
          size="small"
          placeholder="请选择货币类型"
          clearable
          @change="getCurrencyList"
      >
        <el-option
            v-for="item in currencyType"
            :value="item.value"
            :label="item.label"
            :key="item.value"
        ></el-option>
      </el-select>
      <el-select
          v-model="query.active"
          size="small"
          placeholder="请选择激活状态"
          clearable
          @change="getCurrencyList"
      >
        <el-option
            v-for="item in activeType"
            :value="item.value"
            :label="item.label"
            :key="item.value"
        ></el-option>
      </el-select> -->
      <!-- <el-button type="primary" size="small" @click="getMarqueeList" style="margin-right: 10px">搜索</el-button> -->
      <el-button
        type="primary"
        size="small"
        @click="Action('add')"
        class="add-input"
        >新增配置</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
    >
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        fixed
        min-width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        label="跑马灯内容"
        align="center"
        fixed
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.content }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        label="位置"
        align="center"
        fixed
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ handleType(scope.row.type) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="url"
        label="跳转链接"
        align="center"
        min-width="150"
        :formatter="handleUrl"
      >
      </el-table-column>
      <el-table-column
        prop="active"
        label="激活状态"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.active">已激活</el-tag>
          <el-tag type="info" v-else>未激活</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="createAt"
        label="创建时间"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateAt"
        label="更新时间"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="Action('edit', scope.row)"
          ></el-button>
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="del(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="query.pageNumber"
      :page-size="query.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、编辑组件 -->
    <add-and-edit
      ref="addAndEdit"
      @queryMarquee="getMarqueeList"
    ></add-and-edit>
  </div>
</template>

<script>
import { getAnnounceList, deleteAnnounce } from "@/api/marquee.js";
import addAndEdit from "./components/addAndEdit";

export default {
  components: {
    addAndEdit,
  },
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      activeType: [
        { label: "激活", value: true },
        { label: "未激活", value: false },
        { label: "全部", value: undefined },
      ],
      types: [
        {
          label: "首页banner下方",
          value: 1,
        },
        {
          label: "我的banner上方",
          value: 2,
        },
        // {
        //   label: "会员中心-vip卡下方",
        //   value: 3,
        // },
        {
          label: "社区子专题下方",
          value: 4,
        },
        {
          label: "猎奇模块banner广告位下方",
          value: 5,
        },
        {
          label: "私信顶部",
          value: 6,
        },
        {
          label: "片库",
          value: 7,
        },
        {
          label: "福利任务",
          value: 8,
        },
      ],
      urlList: [
        {
          label: "会员中心",
          value: "yinseinner://vip_page",
        },
        {
          label: "钱包",
          value: "yinseinner://wallet_page",
        },
        {
          label: "福利中心",
          value: "yinseinner://freeBenefits",
        },
        {
          label: "预售活动",
          value: "yinseinner://advancePage",
        },
        {
          label: "原味商店",
          value: "yinseinner://shop_page",
        },
        { label: "直播", value: "yinseinner://live" },
      ],
      // 请求参数
      query: {
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.getMarqueeList();
  },
  methods: {
    handleUrl(row) {
      let urlStr = "--";
      this.urlList.forEach((item) => {
        if (item.value == row.url) {
          urlStr = item.label;
        }
      });
      return urlStr;
    },
    handleType(type) {
      let typeStr = "";
      this.types.forEach((item) => {
        if (item.value == type) {
          typeStr = item.label;
        }
      });
      return typeStr;
    },
    // 请求跑马灯列表
    getMarqueeList() {
      this.loading = true;
      getAnnounceList(this.query)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.$message.error("服务端异常");
          this.loading = false;
        });
    },
    // 新增、编辑操作
    Action(type, data) {
      this.$refs.addAndEdit.open(type, data);
    },
    // 删除跑马灯
    del(param) {
      this.$confirm("确认删除此跑马灯的内容吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          let ids = [];
          ids.push(param.id);
          const params = {
            ids: ids,
          };
          deleteAnnounce(params)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.getMarqueeList();
              }
            })
            .catch(() => {
              this.$message.error("服务端异常!");
            });
        })
        .catch(() => {
          this.$message({
            type: "warning",
            dangerouslyUseHTMLString: true,
            message: '<span style="color:blue">已取消了哟！</span>',
          });
        });
    },
    // 分页条数改变回调
    changeSize(size) {
      this.query.pageSize = size;
      this.getMarqueeList();
    },
    // 跳转页数
    changeCurrent(pageNo) {
      this.query.pageNumber = pageNo;
      this.getMarqueeList();
    },
  },
};
</script>

<style lang="scss">
.gold-list-box {
  .add-input {
    margin-left: 0 !important;
  }
}
</style>
